export default "__VITE_ASSET__tg2_4gRs__"